module.exports = __webpack_public_path__ + "img/bike-crash.e67e72bd.svg";